import { ProgressBar } from "primereact/progressbar";
import { useEffect, useState } from "react";
import CmsService from "../../service/CmsService";


export function ProcViewer({service,procId,onOK}){
    const [progress,setProgress] = useState(0);
    const [visible,setVisible] = useState(procId>0);
    const [proc,setProc] = useState(null);
    var interval;

    const displayValueTemplate=(value)=>{
        return (
            <>
                {value} <b>%</b>
            </>
        );
    }    
    const updateProgress=(proc)=>{
        setProc(proc);
        if(proc.status == 'OK')
        {
            setVisible(false);
            clearInterval(interval);
            onOK(proc);
        }
        else
            setVisible(true);
    }
    useEffect(()=>{
        if(procId<=0)
            return;
        interval = setInterval(()=>{
            service.getProc(procId).then((ret)=>{
                console.log('getProc:'+JSON.stringify(ret));
                setProgress(Math.round(ret.totalWork>0?ret.workCompleted*100.0/ret.totalWork:0))
                updateProgress(ret);
            });
        },350);
    },[procId])
    return (
        <>
            <div>
                { proc?<label>{proc.message}</label>:<></>}                
                <ProgressBar value={progress}  className={"mb-4 " + (visible?"":"hidden")} displayValueTemplate={displayValueTemplate}/>                
            </div>
        </>
    )
}